import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { CartProvider } from "./contexts/CartContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { PoweredFooter } from "./components/PoweredFooter";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";

import CustomerHome from "./pages/customer/CustomerHome";
import OrderTracking from "./pages/customer/OrderTracking";
import OrderHistory from "./pages/customer/OrderHistory";
import ProductDetail from "./pages/customer/ProductDetail";
import Checkout from "./pages/customer/Checkout";
import Profile from "./pages/customer/Profile";

import MerchantDashboard from "./pages/merchant/MerchantDashboard";
import RiderDashboard from "./pages/rider/RiderDashboard";
import AdminDashboard from "./pages/admin/AdminDashboard";

function AppRouter() {
  const location = useLocation();
  // Catch Emergent Google OAuth callback FIRST (before ProtectedRoute runs)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* Customer */}
      <Route path="/app" element={<CustomerHome />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/checkout" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/orders" element={<ProtectedRoute roles={["customer", "admin"]}><OrderHistory /></ProtectedRoute>} />
      <Route path="/orders/:id" element={<ProtectedRoute><OrderTracking /></ProtectedRoute>} />

      {/* Merchant */}
      <Route path="/merchant" element={<ProtectedRoute roles={["merchant", "admin"]}><MerchantDashboard /></ProtectedRoute>} />

      {/* Rider */}
      <Route path="/rider" element={<ProtectedRoute roles={["rider", "admin"]}><RiderDashboard /></ProtectedRoute>} />

      {/* Admin */}
      <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRouter />
            <PoweredFooter />
            <Toaster
              position="top-center"
              theme="dark"
              toastOptions={{
                style: {
                  background: "rgba(13,19,31,0.9)",
                  border: "1px solid rgba(0,240,255,0.25)",
                  color: "#F8FAFC",
                  backdropFilter: "blur(16px)",
                },
              }}
            />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
